"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("../");

var _styledUtils = require("@sloth-system/styled-utils");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LogisticTimeLine(props) {
  return _react.default.Children.map(props.children, item => {
    if (item) {
      let active = item.props.active || props.active;
      let {
        line = true
      } = item.props;
      let borderWidth = active ? 2 : 1;

      if (!line) {
        borderWidth = 0;
      }

      return /*#__PURE__*/_react.default.createElement(_.Stack, {
        style: {
          width: "100%",
          position: "relative"
        },
        alignment: "stretch",
        px: "xxl"
      }, /*#__PURE__*/_react.default.createElement(_.Box, {
        style: {
          alignItems: "center",
          paddingTop: 6
        }
      }, active ? props.activeIcon : props.icon, /*#__PURE__*/_react.default.createElement(_.Divider, {
        size: "s"
      }), /*#__PURE__*/_react.default.createElement(_.Box, {
        style: {
          width: 1,
          flexGrow: 1,
          borderRightWidth: borderWidth,
          borderRightRadius: 1,
          borderRightStyle: active ? "solid" : "dashed",
          borderRightColor: active ? (0, _styledUtils.color)("neutrals.250")({
            theme: props.theme
          }) : (0, _styledUtils.color)("text.light950")({
            theme: props.theme
          })
        }
      })), item);
    } else {
      return null;
    }
  });
}

var _default = LogisticTimeLine;
exports.default = _default;